import React from 'react'
import { StyledButton } from './styles'
import LinkComponent from '../../Link'

export function Button({ children, small, variant = 'primary', onClick, href, disabled = false, ...rest }) {
   if (href) {
      return (
         <StyledButton
            as={LinkComponent}
            small={small}
            variant={variant}
            url={href}
            type={href.startsWith('http') ? 'external' : 'internal'}
            {...rest}
         >
            {children}
         </StyledButton>
      )
   }

   return (
      <StyledButton small={small} variant={variant} disabled={disabled} onClick={onClick} {...rest}>
         {children}
      </StyledButton>
   )
}
